import { useMemo } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import XIcon from '../../icons/X.icon';
import Button from '../Button';
import './Modal.styles.scss';

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  size?: 'small' | 'medium' | 'large';
  children: React.ReactNode;
  className?: string;
};

const Modal: React.FC<ModalProps> = (props) => {
  const { isOpen, onClose, title, size = 'small', children, className } = props;

  const classes = classNames('res-modal', size, className);

  const modal = useMemo(
    () => (
      <div className="modal-overlay" onClick={onClose}>
        <div className={classes} onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2>{title}</h2>
            <Button onClick={onClose}>
              <XIcon />
            </Button>
          </div>
          <div className="modal-body">{children}</div>
        </div>
      </div>
    ),
    [children, classes, onClose, title]
  );

  if (!isOpen) return null;

  return ReactDOM.createPortal(modal, document.body);
};

export default Modal;
